import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Card, Col, Row, Space} from 'antd';
import {RocketFilled} from '@ant-design/icons';
import {useTranslations} from '../../lang';
import {DEFAULT_GUTTER} from '../../constants';
import './style.css';

export default function CallToAction({showLogin = false, showHomepageLink = true}) {
    const navigate = useNavigate();
    const {translate: t} = useTranslations();

    return (
        <section aria-labelledby="cta-title" className="pad-2">
            <Row gutter={DEFAULT_GUTTER}>
                <Col span={24}>
                    <Card className="cta-card">
                        <div className="cta-header">
                            <RocketFilled className="cta-icon" aria-hidden="true"/>
                            <h2 id="cta-title" className="cta-title">
                                {t("Klaar om je eerste succesvolle moestuin te plannen?")}
                            </h2>
                            <p className="cta-text">
                                {t("Sluit je vandaag nog aan bij 4.000+ tevreden tuinders")}
                            </p>
                        </div>
                        <Space size="large" wrap>
                            <Button
                                type="primary"
                                size="large"
                                href={"/register?utm_source=seo&utm_medium=blog&utm_campaign=blog-post"}
                                className="btn-cta-primary"
                                icon={<RocketFilled/>}
                            >
                                {t("Start nu gratis")}
                            </Button>
                            {showLogin && (
                                <Button
                                    size="large"
                                    onClick={() => navigate('/login')}
                                    className="btn-cta-secondary"
                                >
                                    {t("Ik heb al een account")}
                                </Button>
                            )}
                            {showHomepageLink && (
                                <Button
                                    size="large"
                                    href={"/?utm_source=seo&utm_medium=blog&utm_campaign=blog-post"}
                                    className="btn-cta-secondary"
                                >
                                    {t("Meer informatie")}
                                </Button>
                            )}
                        </Space>
                        <div className="cta-footer">
                            <p className="cta-footer-text">
                                {t("Gratis voor altijd • Geen verborgen kosten • Annuleer elk moment")}
                            </p>
                        </div>
                    </Card>
                </Col>
            </Row>
        </section>
    );
}
